import { gameBalance } from '@config/gameBalance';
import type { BanknoteInstance, RoundPhase, RoundState } from './banknotes/models/BanknoteTypes';
import type { RoundBanknoteGenerator } from './banknotes/services/RoundBanknoteGenerator';

/**
 * Tek turun saf oyun mantığı — Phaser/UI bağımsız.
 */
export class RoundController {
  private phase: RoundPhase = 'idle';
  private target: BanknoteInstance | null = null;
  private grid: BanknoteInstance[] = [];
  private correctInstanceId: string | null = null;

  constructor(private readonly generator: RoundBanknoteGenerator) {}

  beginRound(): void {
    const roundSet = this.generator.generateRound(gameBalance.gridSize);
    this.target = roundSet.target;
    this.grid = [...roundSet.grid];
    this.correctInstanceId = roundSet.target.instanceId;
    this.phase = 'preview';
  }

  enterGridPhase(): void {
    if (this.phase !== 'preview') {
      return;
    }
    this.phase = 'grid';
  }

  evaluateSelection(instanceId: string): boolean {
    if (this.phase !== 'grid' || !this.correctInstanceId) {
      return false;
    }

    this.phase = 'locked';
    return instanceId === this.correctInstanceId;
  }

  getState(): RoundState {
    return {
      phase: this.phase,
      target: this.target,
      grid: [...this.grid],
      correctInstanceId: this.correctInstanceId,
    };
  }

  reset(): void {
    this.phase = 'idle';
    this.target = null;
    this.grid = [];
    this.correctInstanceId = null;
  }
}
